import { z } from "zod";

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000" as const;

export type Address = `0x${string}`;

export type NativeCurrency = {
  name: string;
  symbol: string;
  decimals: number;
};

export type ChainContracts = {
  erc721Factory: Address;
  erc721DropImpl: Address;
  erc721SimpleImpl: Address;
  atelier1of1?: Address | undefined;
};

export type ChainMeta = {
  chainId: number;
  name: string;
  shortName: string;
  rpcUrl: string;
  explorerUrl: string;
  nativeCurrency: NativeCurrency;
  ipfsGateway?: string | undefined;
  enabled: boolean;
};

export type ChainConfig = ChainMeta & {
  contracts: ChainContracts;
};

export const addressSchema = z
  .string()
  .regex(/^0x[0-9a-fA-F]{40}$/u, "invalid address")
  .transform((v) => v.toLowerCase() as Address);

export const chainMetaSchema = z.object({
  chainId: z.number().int().positive(),
  name: z.string().min(1).max(64),
  shortName: z
    .string()
    .min(1)
    .max(32)
    .regex(/^[a-z0-9-]+$/u, "shortName must be kebab/lowercase"),
  rpcUrl: z.string().url(),
  explorerUrl: z.string().url().or(z.literal("")),
  nativeCurrency: z.object({
    name: z.string().min(1),
    symbol: z.string().min(1).max(12),
    decimals: z.number().int().min(0).max(36),
  }),
  ipfsGateway: z.string().url().optional(),
  enabled: z.boolean(),
});
